import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { finalize, Observable, map, tap, shareReplay } from 'rxjs';
import { advisor } from 'src/models/advisor';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { ServiceSchedule } from 'src/services/api-services/api-interfaces/api-interface-service-schedule';
import { Representative } from 'src/services/api-services/api-interfaces/api-representative.interface';
import { CustomSchedule } from 'src/services/api-services/api-interfaces/custom-schedule.interface';
import { CustomerBasicData } from 'src/services/api-services/api-interfaces/customerBasicData.interface';
import { ValidatedCustomer } from 'src/services/api-services/api-interfaces/CustomerValidated.interface';
import { Scheduler } from 'src/services/api-services/api-interfaces/scheduler.interface';
import { ServiceAdvisor } from 'src/services/api-services/api-interfaces/ServiceAdvisor.interface';
import { typeOfService } from 'src/services/api-services/api-interfaces/typeOfService.interface';
import { VehicleData } from 'src/services/api-services/api-interfaces/vehicleData.interface';
import { APIRepresentativeService } from 'src/services/api-services/api-representative-service';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { APIService } from 'src/services/api-services/api-service';
import { APIServiceAdvisorSchedule } from 'src/services/api-services/api-service-advisor-schedule';
import { APIAttentionSchedule } from 'src/services/api-services/api-service-attention-schedule';
import { APIServiceSchedule } from 'src/services/api-services/api-service-schedule';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { VehicleDataService } from 'src/services/api-services/vehicleData-service';
import { HelperService } from 'src/services/helperService';
import { Workshop } from '../../../../../models/workshop';
import { ServiceAttentionSchedule } from '../../../../../services/api-services/api-interfaces/api-interface-attention-schedule';
import { ServiceAdvisorShedule } from '../../../../../services/api-services/api-interfaces/api-interface-service-advisor-schedule';
import { APIDealerBlockedServices } from '../../../../../services/api-services/api-dealer-blocked-services';
import { TranslateService } from '@ngx-translate/core';
import { APIDocumentTypeService } from 'src/services/api-services/api-document-type.service';
import { CreateSchedulerData } from 'src/services/api-services/api-interfaces/api-interface-create-scheduler';

export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}

@Component({
    selector: 'app-choose-service',
    templateUrl: './choose-service.component.html',
    styleUrls: ['./choose-service.component.sass'],
    standalone: false
})
export class ChooseServiceComponent implements OnInit {
 
  validateDate = true;
  brandUrl: string = '';
  public vehicleBrand: string = '';
  owner: boolean = true
  public ToSName: any= {};
  public workShopName: string = '';
  public advisorName: string = '';
  public cityName: string = history.state.cityName;
  recievedLanguageForCountry:any = history.state.LanguageForCountry as {}
  public recievedCountryData: any = history.state.country as {}
  public recievedCityData : any = history.state.cityId  as {}
  public isNewUser = true; 
  documentType: any[]=[]
 
  selectOwnerOnSite:string="true"
  searchedId:string = ""
  public static dato : any 
  isLoading: boolean = false
  public militarTime: string=''

  public recievedScheduledData: any = history.state.schedule as {};
  recievedCity: number = history.state.city
  recievedCityName: string = history.state.cityName
  public TermAndConditiosMode:string = "Default"
  indexbrand: string ='';
  SelectYourService:string = "Elige tu servicio"
  FinalizeReservationr:string = "Finaliza tu reserva"
  CompleteData:string = "Completa tus datos"
  nameDocumentType:any =""
  public recievedBrand: any = history.state.brand as {}
  public PlaceHolderObservations :string =""
  public workshops?
  

  public editButton: boolean = true;
  public showForm: boolean = false;
  public TermsAccepted: boolean = false
  public dataProtectionPolitics: boolean = false
  public isOwnerOnSite: boolean = true
  public canTakeDecisionValue:boolean = false
  public loadingSerchPlate:boolean = false
  public date ?
  public time

  public servicesResp:typeOfService[]=[]
  public advisorData:ServiceAdvisor[]=[]
  public customerBasicDataResp
  public vehicleDataResp
  public RepresentativeDataResp
  public scheduleDataResp
  public customerBasicDataRespPost
  public vehicleDataRespPost
  public RepresentativeDataRespPost
  public scheduleDataRespPost
  public attentionScheduleWorkshop: ServiceAttentionSchedule[] = []
  public defaultAttentionScheduleWorkshop: ServiceAttentionSchedule[] = []
  public timeButtons: any[] = []
  workshopResp: Workshop[] = [];
  defaultWorkshops: Workshop[] = [];
  advisorsresp: ServiceAdvisor[] = []
  defaultAdvisorsResp:ServiceAdvisor[] = []
  advisors: any[] = [];
  workshopss!: Workshop;
  workshopssResp: Workshop[] = [];
  //completas tus datos
  selectedDocumentType!: string
  selectedCode!: string;
  workshopName?: string = ''
  serviceAdvisorAttentionSchedule: ServiceAdvisorShedule[] = []
  defaultserviceAdvisorAttentionSchedule:ServiceAdvisorShedule[] = []
  public bannerSuccesURL=''
  public disclaimer:string =""
  task: Task = {
    name: 'Indeterminate',
    completed: false,
    color: 'primary',
    subtasks: [
      { name: 'Primary', completed: false, color: 'primary' },
      { name: 'Accent', completed: false, color: 'accent' },
      { name: 'Warn', completed: false, color: 'warn' },
    ],
  };
  busyDates :number[] = [1, 5, 3, 2, 4, 6]
  public edited = false;
  public edited2 = false;
  public details = false;
  public userSearched: boolean = false;
  public representativeDatacountry
  public userData 
  public typeOfServiceId?;
  public workshopId?;
  public advisorId?;
  public typesOfservice:typeOfService[] =[];
  public serviceIdResponse:number = 0
  public workShopId: number =0
  public UrlTermAndConditionBelgica
  public scheduleAppointmentURL=''
  public tooltip:string = ""
  public tooltipWorkshop:string = ""

  constructor(private formBuilder : FormBuilder, private route: ActivatedRoute, private router: Router,
    public helperService: HelperService,
    public Service: APIService,
    public WorkshopService: APIWorkshopService,
    public AdvisorsData: APIServiceAdvisorService,
    public customerBasicDataService: APICustomerBasicDataService,
    public vehicleDataService: VehicleDataService,
    public customScheduleService: APICustomScheduleService,
    public schedulerService: APISchedulerService,
    public customersBasicData: APICustomerBasicDataService,
    public RepresentativeServiceApi: APIRepresentativeService,
    public ServiceSchedule: APIServiceSchedule,
    public attetionSchedulerservice: APIAttentionSchedule,
    public AdvisorScheduleService: APIServiceAdvisorSchedule ,
    public dealerBlockedServices: APIDealerBlockedServices,private translate: TranslateService, public representativeDataService: APIRepresentativeService, public APIServicetypeDocument: APIDocumentTypeService,
  ) {  }
  ngOnInit(): void {
    this.traductionData()
    this.getDocumentsTypeForContry()
    this.hourMaxAndMinimum()
    this.route.params.subscribe(params => {
      this.brandUrl = params['brand'];
    });
    
    this.bannerSuccesURL = `WebView/bannerSuccess/${this.brandUrl}/${this.recievedCountryData}`
    this.scheduleAppointmentURL = `WebView/bannerManage/${this.brandUrl}/${this.recievedCountryData}`
    this.evaluateOldSchedule();
    this.SelectForCountryTermAndConditions()

    
  }
  traductionData(){
    this.disclaimer = this.translate.instant('disclamermilegs'); 
    this.PlaceHolderObservations= this.translate.instant('PlaceHolderObservations'); 
    this.SelectYourService= this.translate.instant('SelectYourService'); 
    this.FinalizeReservationr= this.translate.instant('FinalizeReservationr')
    this.CompleteData= this.translate.instant('CompleteData')
    this.tooltip = this.translate.instant('tooltip'); 
    this.tooltipWorkshop = this.translate.instant('tooltipWorkshop')
    switch(this.recievedLanguageForCountry){
      case'es-CO': case 'en-US':
        this.UrlTermAndConditionBelgica =  "https://afr-stage-byd.bydauto.be/en/privacypolicy/" 
      break
      case'du-BE':
        this.UrlTermAndConditionBelgica =  "https://afr-stage-byd.bydauto.be/fr/privacypolicy/" 
      break
      case'fr-BE':
        this.UrlTermAndConditionBelgica =  "https://afr-stage-byd.bydauto.be/privacypolicy/" 
      break
    }
  }
  getDocumentsTypeForContry(){
    this.APIServicetypeDocument.GetByCountryId(this.recievedCountryData).pipe(
      tap((response) => {
        if (!response.message) {
        this.documentType = response
        }
        else{}
      })).subscribe({
        error: () => {
          const translateTxtNotMatch = this.translate.instant("notMatchFound") 

          this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)

        }
      });
  }
  NameDocument()
 {
  this.nameDocumentType = this.documentType.filter(s=> s.typeId === Number(this.formValidation2.value.tip_Doc))[0]
 }
 backInitialChoose(){
  this.router.navigate([this.scheduleAppointmentURL]);
 }
 formsValidations(): boolean {
  if(this.isOwnerOnSite){  return this.formValidation2.invalid }

  else{
    if( this.formValidation2.invalid ) {return true}
    else {return this.formValidation_representative.invalid}
  }
}
hourMaxAndMinimum(){
this.attetionSchedulerservice.getWebViewMAxAndMinimumHours(this.recievedCountryData,this.recievedCityData,this.recievedBrand).pipe(tap((response) => {
  if (!response.message) {
   
 let hoursUtilication = response[0]
   let dateDuration = hoursUtilication.minDateLength;
  if( hoursUtilication.minDateLength <60){
    dateDuration = `00:${ hoursUtilication.minDateLength}:00`
  }
  else if( hoursUtilication.minDateLength >=60)
  {
    dateDuration = `01:${ hoursUtilication.minDateLength-60}:00`
  }
   let interval = moment.duration(dateDuration).asHours();
      const hourNumArr =  hoursUtilication.minHourInitial.split(':')
      const hourNumArrF = hoursUtilication.maxHourFinal.split(':')
      this.timeButtons = [];
      for ( let i = Number(hourNumArr[0]); i <Number( hourNumArrF[0]); i += interval) {
        let time = ('0' + (Math.floor(i) % 24)).slice(-2) +':' +((i % 1) * 60 + '0').slice(0, 2);
        let amFormat = moment(time, 'HH:mm:ss').format('h:mm A.');
        let hoursSplit = amFormat.split(' ');
        let replaceHours = {hours: hoursSplit[1].replace(hoursSplit[1], `${hoursSplit[0]} ${hoursSplit[1][0]}.${hoursSplit[1][1]}.`),class:"btn-hour"}
        this.timeButtons.push(replaceHours);
        this.timeButtons = [...new Set(this.timeButtons)];
      }

      this.DateFilter(new Date());
  }
})).subscribe();
}

getWorkshopForHour(){
  this.customScheduleService.getWebviewHoursWorkshopDropDownLists(moment(this.date,"DD/MM/YYYY").format('YYYY-MM-DD'),moment(this.time, 'h:mm A').format('HH:mm:ss'),this.recievedCityData,this.serviceIdResponse,this.recievedBrand).pipe(tap((response) => {
    if (!response.message) {  
    this.workshops= response
    }
  })).subscribe();
}
daysForMonthNow(year,mounth,day) {
  var date = new Date(year+"/"+mounth+"/"+day);
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}
DateFilter = (date: Date | any) => {
  let day = date.getDay();
  this.busyDates =  [1, 5, 3, 2, 4, 6]
  let limitDate = new Date(new Date().getFullYear() + '-' +('0' + (new Date().getMonth() + 6) ).slice(-2) + '-' + this.daysForMonthNow(new Date().getFullYear() ,new Date().getMonth() + 6,"01") + 'T23:59')
  if(new Date().getMonth() + 7 > 12){
    limitDate = new Date(new Date().getFullYear()+1 + '-' +('0' + (new Date().getMonth() + 6 - 12) ).slice(-2) + '-' + this.daysForMonthNow(new Date().getFullYear()+1 ,new Date().getMonth() + 6 - 12,"01") + 'T23:59')
  }
  const limitDatenumber = limitDate.getTime()
   return (
    date.setHours(0, 0, 0, 0)>new Date().setHours(0, 0, 0, 0) &&(
    day === this.busyDates[0] ||
    day === this.busyDates[1] ||
    day === this.busyDates[2] ||
    day === this.busyDates[3] ||
    day === this.busyDates[4] ||
    day === this.busyDates[5] ||
    day === this.busyDates[6] ) 
    && date<=limitDatenumber 
   );
  };
SelectForCountryTermAndConditions(){
  
    switch(Number(this.recievedCountryData))
    {
      case 1:
        // Colombia
        if(Number(this.recievedBrand )=== 2){
            this.TermAndConditiosMode = "Colombia"
        }

      break;
      case 2:
        // Peru
        if(Number(this.recievedBrand )=== 4 || Number(this.recievedBrand )=== 5 || Number(this.recievedBrand )=== 6){
            this.TermAndConditiosMode = "Peru"
        }
        if(Number(this.recievedBrand )=== 2 || Number(this.recievedBrand )=== 3){
          this.TermAndConditiosMode = "Peru2"}

            if(Number(this.brandUrl )=== 8 ){
      
          this.TermAndConditiosMode = "Derco"
      }

      break;
      case 3:
      // chile
      if(Number(this.recievedBrand )=== 4 || Number(this.recievedBrand )=== 5 || Number(this.recievedBrand )=== 6){

        this.TermAndConditiosMode = "Chile"
       }
      break;

      case 4:
      // chile
      if(Number(this.recievedBrand )=== 7 ){

        this.TermAndConditiosMode = "Bélgica"
       }
      break;
      
    }
}

  isOwner(e) {
    if (e.target.value==='false') {this.owner = false}
    else {this.owner=true }
  }

  onIconMouseHoverAndOut(
    elementId: string,
    className: string,
    isFill: boolean
  ) {
    if (isFill) {
      document.getElementById(elementId)?.classList.add(className + '-fill');
      document.getElementById(elementId)?.classList.remove(className);
    } else {
      document.getElementById(elementId)?.classList.add(className);
      document.getElementById(elementId)?.classList.remove(className + '-fill');
    }
  }

  toBoolean(event) {
    const value = event.target.value;
    this.isOwnerOnSite = value === 'true';
  }
  evaluateOldSchedule() {
       this.customScheduleService.getScheduleDropDownListsWebview(this.recievedCountryData,this.recievedBrand,this.recievedCityData).pipe(tap((response) => {
          if (!response.message) {
             this.typesOfservice =  response   
          }
        })).subscribe();} 

// Funcion validate not

onWorkshopChange(object:any) {
  const dateWorkshop =  this.workshops.filter(service => service.workshopId === object)[0]
  this.workShopName = dateWorkshop.workshopName;
  this.workShopId = dateWorkshop.workshopId;
  let originalWorkshopId = dateWorkshop.originalWorkshopId

  this.AdvisorScheduleService.getWebviewHoursAdvisorDropDownLists(moment(this.date,"DD/MM/YYYY").format('YYYY-MM-DD'),moment(this.time, 'h:mm A').format('HH:mm:ss'),this.serviceIdResponse,originalWorkshopId,this.recievedBrand).pipe(tap((response) => {
    if (!response.message) {  
    this.advisors = response
    }
    
  })).subscribe({
    error: () => {
      const translateTxtNotMatch = this.translate.instant("notMatchFound") 

      this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
    }
  });
  }

  
  onAdvisorChange(value) {
    const dateAdvisor =  this.advisors.filter(service => service.advisorId === value)[0]
  
    this.advisorName = dateAdvisor.advisorName;
    this.advisorId = dateAdvisor.advisorId 
    //event is the service advisorID
  }

  onChangeTypeOfService(id:number) {
    const dateTypeOfService = this.typesOfservice.filter(service => service.serviceId === id)[0]
    this.ToSName = dateTypeOfService;
    this.serviceIdResponse = dateTypeOfService.serviceId
  }

  
  
  nextDisabled(): boolean {
    if (this.date === undefined || this.date === '' || this.time === '' ||  this.formValidation.controls.kilometraje.value === "" || this.formValidation.value.asesor === "" ||this.formValidation.value.taller === "") {
      return true;
    } else return false;
  } 
  serchrepresentrative()
  {
    this.vehicleDataService
    .getValidatedData(this.recievedScheduledData.plateNo, this.recievedScheduledData.documentNumber)
    .pipe(
      tap((response) => {
        if (!response.message) {
          this.userData = response;
        
          
          this.representativeDataService.getForCustomerId(this.userData[0].customerId).pipe(
            tap((response) => {
              if (!response.message) {
                
              this.representativeDatacountry = response;
              this.formValidation_representative.patchValue({
                representativeDocumentNumber: this.representativeDatacountry.identification,
                representativeName:this.representativeDatacountry.firstName,
                representativeLastName:this.representativeDatacountry.lastName,
                representativePhone:this.representativeDatacountry.phone,
                representativeCountryCode:'57',
                representativeDocumentType: this.representativeDatacountry.documentType,
                representativecorreo:this.representativeDatacountry.email
              })

              }
              else{
                this.representativeDatacountry ={representativeId:0}
                this.formValidation_representative.patchValue({
                  representativeDocumentNumber: '',
                  representativeName:'',
                  representativeLastName:'',
                  representativePhone:'',
                  representativeCountryCode:''
                })
              }
            })
            
          )
          .subscribe();
        } else {
          // this.userData[0]=[{vehicleId : 0,customerId : 0}]
          this.userData = [{vehicleId : 0,customerId : 0}]
          this.representativeDatacountry ={representativeId:0}
        
          this.formValidation2.patchValue({
            tip_Doc: 0,
            nombres: '',
            apellidos: '',
            cod_pais: '',
            celular: '',
            correo: '',
            vin: '',
            terms: false,
            politics: false,
          });
        }
      }),
    ).subscribe({
      error: () => {
        const translateTxtNotMatch = this.translate.instant("notMatchFound") 
        this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
      }
    });
  }
  isNewSchedule(): boolean {
    return this.recievedScheduledData.id === '';
  }
  onPlateNumberSearchClick()
  
  {
   // reset fields
   this.edited=false
   this.edited2=false
   this.isNewUser = true;
   this.loadingSerchPlate = true
   this.formValidation2.patchValue({
     tip_Doc: 0,
     nombres: '',
     apellidos: '',
     cod_pais: '',
     celular: '',
     correo: '',
     vin: '0',
     terms: false,
     politics: false,
   });
  this.vehicleDataService
    .getValidatedData(this.placaControl.value, this.cedulaControl.value)
    .pipe(
      tap((response) => {
        this.userSearched = true;
        if (!response.message) {
          this.userData = response;
          this.isNewUser = false;
          this.edited=true
          this.edited2=true
          this.loadingSerchPlate = false
          this.formValidation2.patchValue({
            cedula: this.userData[0].identification,
            tip_Doc: this.userData[0].typeId ,
            nombres: this.userData[0].firstName,
            apellidos: this.userData[0].lastName,
            cod_pais: '+57',
            celular: this.userData[0].phone,
            correo: this.userData[0].email,
            vin: this.userData[0].vin,
            terms: false,
            politics: false,
          }
          ); 
          this.representativeDataService.getForCustomerId(this.userData[0].customerId).pipe(
            tap((response) => {
              if (!response.message) {
              this.representativeDatacountry = response;
              this.formValidation_representative.patchValue({
                representativeDocumentNumber: this.representativeDatacountry.identification,
                representativeName:this.representativeDatacountry.firstName,
                representativeLastName:this.representativeDatacountry.lastName,
                representativePhone:this.representativeDatacountry.phone,
                representativeCountryCode:'57',
                representativeDocumentType: this.representativeDatacountry.documentType,
                representativecorreo:this.representativeDatacountry.email
              })

              }
              else{
            
                this.representativeDatacountry ={representativeId:0}
                this.formValidation_representative.patchValue({
                  representativeDocumentNumber: '',
                  representativeName:'',
                  representativeLastName:'',
                  representativePhone:'',
                  representativeCountryCode:''
                })
              }
            })
            
          )
          .subscribe();
          this.loadingSerchPlate = false
        } else {
          // this.userData[0]=[{vehicleId : 0,customerId : 0}]
          this.userData = [{vehicleId : 0,customerId : 0}]
          this.representativeDatacountry ={representativeId:0}
         
          this.formValidation2.patchValue({
            tip_Doc: 0,
            nombres: '',
            apellidos: '',
            cod_pais: '',
            celular: '',
            correo: '',
            vin: '',
            terms: false,
            politics: false,
          });
        }
        this.loadingSerchPlate = false
        this.details = true;
      }),
    
    ).subscribe({
      error: () => {
        const translateTxtNotMatch = this.translate.instant("notMatchFound") 
        this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
      }
    });  
  }
  transformInput({ target }) {
    target.value = target.value.toUpperCase().replace(/\s/g, '');
  }
  
  timeValue(e) {
    this.time = e;

    if(this.date && this.time)
    {
      this.resetForNewTime()
      this.getWorkshopForHour()}
    
  }
  dateValue(e) {
    this.date = e;
 
    if(this.date && this.time)
    {
      this.resetForNewTime()
      this.getWorkshopForHour()}
    
  }

  resetForNewTime(){
    this.formValidation.value.asesor= ""
    this.formValidation.value.taller= ""
    this.tallerControl.setValue("")
    this.asesorControl.setValue("")
    this.workShopName = "";
    this.workShopId = 0;
    this.advisorName =  "";
    this.advisorId = 0
    this.advisors=[]
    this.workshops=[]
  }

 

onSave() {
  // POST
    
    
  let customschedulerData :CreateSchedulerData
  this.isLoading = true;

 
   // picked date om bd format
   let bdDateFormat = this.date.split('/');
   bdDateFormat = `${bdDateFormat[2]}-${bdDateFormat[1]}-${bdDateFormat[0]}`;
   let bdTimeFormat = moment(this.time, ['h:mm A']).format('HH:mm:ss');

   customschedulerData = {
     createSchedulerDTO:{
       scheduleId:0,
       customerId: this.userData[0].customerId ,
       advisorId:  Number(this.formValidation.value.asesor),
       vehicleId:  this.userData[0].vehicleId,
       date: bdDateFormat,
       time: bdTimeFormat,
       observations:  String( this.formValidation.value.observations ),
       ownerOnSite:  this.isOwnerOnSite,
       termsAndConditions:Boolean( this.formValidation2.value.terms ),
       dataProtectionPolitics: Boolean( this.formValidation2.value.politics),
       representativeId: this.representativeDatacountry.representativeId,
       decisionMaking:  true,
       countryBrandRetailId: this.workShopId,
       schedulerStatusId:  1,
       serviceId:  Number(this.formValidation.value.tip_service),
       originId:  4
     },
     
   vehicleDataDTO: {
     vehicleId: this.userData[0].vehicleId,
     plate:  String(this.formValidation2.value.placa),
     vin:  this.isNewUser ? "0" : String(this.formValidation2.value.vin),
     color: '',
     brand: this.vehicleBrand,
     mileage: String(this.formValidation.value.kilometraje),
     customerId: this.userData[0].customerId,ModelDescription: this.userData[0].model,ModelYear: this.userData[0].año,
   },
   customerBasicDataDTO: {
     customerId: this.userData[0].customerId,
     sapCustomerId: "0",
     identification: String(this.formValidation2.value.cedula),
     documentType: Number(this.formValidation2.value.tip_Doc),
     firstName:  String(this.formValidation2.value.nombres),
     lastName: String(this.formValidation2.value.apellidos),
     email: String(this.formValidation2.value.correo),
     phone: String(this.formValidation2.value.celular),
     address: "",
     relationshipVehicleId: 1
   },
   representativeDTO: {
     representativeId: this.representativeDatacountry.representativeId,
     customerId: this.userData[0].customerId,
     identification: String( this.formValidation_representative.value.representativeDocumentNumber ),
     documentType: Number( this.formValidation_representative.value.representativeDocumentType ),
     firstName: String( this.formValidation_representative.value.representativeName ),
     lastName:  String(this.formValidation_representative.value.representativeLastName),
     email:String(this.formValidation_representative.value.representativecorreo),
     phone: String(this.formValidation_representative.value.representativePhone),
     address: ""
   },utmDTO: {
    UtmSource:"" ,
    UtmCampaign:"" ,
    UtmMedium:"" ,
    UtmContent:"" ,
    UtmTerm: ""
  },RecaptchaToken:"OK"

     
   }

   this.schedulerService.postDataScheduler(customschedulerData).pipe(tap( (response) =>{ 
    
     this.isLoading = false;
     this.router.navigate([this.bannerSuccesURL],{ state: { AppointmentInfo: response.dataLayer[0] } });
   
   }
   )).subscribe()
  
  }




//used for validation purposes
get cedulaControl(): FormControl {
  return this.formValidation2.get('cedula') as FormControl;
}
get placaControl(): FormControl {
  return this.formValidation2.get('placa') as FormControl;
}
get tip_DocControl(): FormControl {
  return this.formValidation2.get('tip_Doc') as FormControl;
}
get nombresControl(): FormControl {
  return this.formValidation2.get('nombres') as FormControl;
}
get apellidosControl(): FormControl {
  return this.formValidation2.get('apellidos') as FormControl;
}
get cod_paisControl(): FormControl {
  return this.formValidation2.get('cod_pais') as FormControl;
}
get celControl(): FormControl {
  return this.formValidation2.get('celular') as FormControl;
}

get correoControl(): FormControl {
  return this.formValidation2.get('correo') as FormControl;
}
get vinControl(): FormControl {
  return this.formValidation2.get('vin') as FormControl;
}
get termsCheckedControl(): FormControl {
  return this.formValidation2.get('terms') as FormControl;
}
get dataProtectionPoliticsControl(): FormControl {
  return this.formValidation2.get('politics') as FormControl;
}
get representativeDocumentTypeControl(): FormControl {
  return this.formValidation_representative.get(
    'representativeDocumentType'
  ) as FormControl;
}

get representativeDocumentNumberControl(): FormControl {
  return this.formValidation_representative.get(
    'representativeDocumentNumber'
  ) as FormControl;
}
get representativeNameControl(): FormControl {
  return this.formValidation_representative.get(
    'representativeName'
  ) as FormControl;
}
get representativeLastNameControl(): FormControl {
  return this.formValidation_representative.get(
    'representativeLastName'
  ) as FormControl;
}
get representativeCountryCodeControl(): FormControl {
  return this.formValidation_representative.get(
    'representativeCountryCode'
  ) as FormControl;
}
get representativePhoneControl(): FormControl {
  return this.formValidation_representative.get(
    'representativePhone'
  ) as FormControl;
}
get representativeRelationWithOwnerControl(): FormControl {
  return this.formValidation_representative.get(
    'representativeRelationWithOwner'
  ) as FormControl;
}
get representativecorreoControl(): FormControl {
  return this.formValidation_representative.get(
    'representativecorreo'
  ) as FormControl;
}
get tip_serviceControl(): FormControl {
  return this.formValidation.get('tip_service') as FormControl;
}
get kilometrajeControl(): FormControl {
  return this.formValidation.get('kilometraje') as FormControl;
}
get tallerControl(): FormControl {
  return this.formValidation.get('taller') as FormControl;
}
get asesorControl(): FormControl {
  return this.formValidation.get('asesor') as FormControl;
}
get observationsControl(): FormControl {
  return this.formValidation.get('observations') as FormControl;
}

formValidation = this.formBuilder.group({
  tip_service: [-1, Validators.required],
  observations: [''],
  kilometraje: [
    '',
    {
      validators: [Validators.required, Validators.pattern(/^([0-9])*$/)],
    },
  ],
  taller: ['', Validators.required],
  asesor: ['', Validators.required],
});

firstFormGroup = this.formBuilder.group({
  firstCtrl: ['', Validators.required],
  tip_service: ['', Validators.required],
  kilometraje: [
    '',
    {
      validators: [Validators.required, Validators.pattern(/^([0-9])*$/)],
    },
  ],
  taller: ['', Validators.required],
  asesor: ['', Validators.required],
});

formValidation2 = this.formBuilder.group({
  placa: ['', Validators.required],
  cedula: ['', Validators.required],
  tip_Doc: [0, Validators.required],
  nombres: [
    '',
    {
      validators: [Validators.required],
    },
  ],
  apellidos: [
    '',
    {
      validators: [Validators.required],
    },
  ],
  cod_pais: [''],
  celular: [
    '',
    {
      validators: [Validators.required, Validators.pattern(/^([0-9])*$/)],
    },
  ],
  correo: [
    '',
    {
      validators: [Validators.required, Validators.email],
    },
  ],
  vin: [''],
  terms: [false, Validators.requiredTrue],
  politics: [false, Validators.requiredTrue],
  isOwnerOnSite: [null, Validators.required],
});

formValidation_representative = this.formBuilder.group({
  representativeDocumentType: ['', Validators.required],
  representativeDocumentNumber: [
    '',
    {
      validators: [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]*$/),
        Validators.minLength(5),
      ],
    },
  ],
  representativeName: ['', Validators.required],
  representativeLastName: ['', Validators.required],
  representativeCountryCode: [''],
  representativePhone: [
    '',
    {
      validators: [Validators.required, Validators.pattern(/^([0-9])*$/)],
    },
  ], 
  representativecorreo: [
    '',
    {
      validators: [Validators.required, Validators.email],
    },
  ],

  representativeRelationWithOwner: ['', Validators.required],
  canTakeDecision: [false],
});
    
  
}